import getCommonDataBank from "@/router/middleware/getCommonDataBank";
export default {
    path: 'directories',
    name: 'directories',
    component: () => import(/* webpackChunkName: "directories" */ '@/views/admin/Directories/index.vue'),
    children: [
        {
            path: 'banks-and-offices',
            name: 'banksAndOffices',
            component: () => import(/* webpackChunkName: "banksAndOffices" */ '@/views/admin/Directories/BanksAndOffices.vue'),
        },
        {
            path: 'bank-questionnairies',
            name: 'bankQuestionnairies',
            component: () => import(/* webpackChunkName: "bankQuestionnairies" */ '@/views/admin/Directories/BankQuestionnairies.vue'),
        },
        {
            path: 'application-statuses-fl',
            name: 'applicationStatusesFl',
            component: () => import(/* webpackChunkName: "applicationStatuses" */ '@/views/admin/Directories/ApplicationStatusesFL.vue'),
        },
        {
            path: 'documents-types',
            name: 'documentsTypes',
            component: () => import(/* webpackChunkName: "documentsTypes" */ '@/views/admin/Directories/DocumentsTypes.vue'),
            meta: {
                middleware: [
                    getCommonDataBank,
                ]
            }
        },
        {
            path: 'notifications',
            name: 'notifications',
            component: () => import(/* webpackChunkName: "notifications" */ '@/views/admin/Directories/Notifications.vue'),
        },
        {
            path: 'notifications-fl',
            name: 'notificationsFl',
            component: () => import(/* webpackChunkName: "notifications" */ '@/views/admin/Directories/NotificationsFL.vue'),
        },
        {
            path: 'about-system',
            name: 'aboutSystem',
            component: () => import(/* webpackChunkName: "aboutSystem" */ '@/views/admin/Directories/AboutSystem.vue'),
        },
    ]
};
